import { type RefObject } from 'react';

import {
  type EmbeddedPaymentElementConfiguration,
  type IntentConfiguration,
} from '@stripe/stripe-react-native';

import {
  currencyCode,
  googlePayConfig,
  merchantDisplayName,
  paymentMethodOptions,
  paymentMethodTypes,
  paymentMethodTypesWithCashApp,
  returnURL,
  setupFutureUsage,
  stripeAppearance,
  walletConfig,
} from './constants';

export function getElementConfig(params: ElementConfigParams): EmbeddedPaymentElementConfiguration {
  const { stripeCustomerId, stripeCustomerKey } = params;

  return {
    merchantDisplayName,
    returnURL,
    applePay: walletConfig,
    googlePay: googlePayConfig,
    customerId: stripeCustomerId,
    customerEphemeralKeySecret: stripeCustomerKey,
    appearance: stripeAppearance,
  };
}

export function getIntentConfig(params: IntentConfigParams): IntentConfiguration {
  const { isPaymentStatePollingEnabled, amount, stripeConfirmHandlerRef } = params; // prettier-ignore

  return {
    confirmHandler: async (paymentResult, shouldSavePaymentMethod, intentCreationCallback) => {
      stripeConfirmHandlerRef?.current?.(
        paymentResult,
        shouldSavePaymentMethod,
        intentCreationCallback,
      );
    },
    // @ts-expect-error - The Stripe SDK is not typed correctly.
    paymentMethodOptions,
    paymentMethodTypes: isPaymentStatePollingEnabled
      ? paymentMethodTypesWithCashApp
      : paymentMethodTypes,
    mode: isPaymentStatePollingEnabled
      ? { amount, currencyCode }
      : { amount, currencyCode, setupFutureUsage },
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type IntentConfigParams = {
  isPaymentStatePollingEnabled: boolean;
  amount: number;
  stripeConfirmHandlerRef: RefObject<NonNullable<IntentConfiguration['confirmHandler']>>; // prettier-ignore
};

type ElementConfigParams = {
  stripeCustomerId: string;
  stripeCustomerKey: string;
};
